<template>
    <div class="productoutsource">
         <!--banner-->
      <div class="banner outer">
        <div class="inside1490">
           <h1 class="banner_title">易猎云外包管理系统
            <!-- <span class="banner_rpo">RPO版</span> -->
           </h1>
           <p class="banner_txt">易猎云外包管理系统是一款专为人力资源服务企业打造<br/>的HRO系统，致力于帮助外包企业高效地管理外包项<br/>目、提升外包服务质量，并优化成本控制</p>
        </div>
      </div>
       <!--图片文字排版1-->
       <div class="outer">
        <div class="inside1490 textimgbox">
          <img
            class="fl"
            style="width: 768px;height: 378px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/new_pic_01%402x.png"
          />
          <div class="fr">
            <h2>人事统筹管理</h2>
            <p class="text_detail">员工入离职手续在线办理<br/> 支持自定义收集入职材料<br/> 实时联动招聘系统候选人员状态</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--文字图片排版2-->
        <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">电子合同管理</h2>
            <p class="text_detail">全流程覆盖候选人的合同配置、签章<br/> 合同在线签署、合同到期预警<br/> 合同永久存储，查找更便捷</p>
          </div>
          <img
            class="fr"
            style="width: 768px;height: 457px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_02%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--图片文字排版1-->
       <div class="outer">
        <div class="inside1490 textimgbox">
          <img
            class="fl"
            style="width: 768px;height: 378px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_03%402x.png"
          />
          <div class="fr">
            <h2>人事管理数据分析</h2>
            <p class="text_detail">员工入职、在职数据分析<br/> 员工流失趋势、流失原因分析<br/> 人事决策数据支撑</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--文字图片排版2-->
        <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">商保&社保&公积金</h2>
            <p class="text_detail">线上提报，自动提醒，避免数据错漏<br/>支持配置社保、公积金、调基变更<br/>员工参保方案线上维护，降低用工风险</p>
          </div>
          <img
            class="fr"
            style="width: 748px;height: 497px;margin-top: 100px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_04%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <!--图片文字排版1-->
      <div class="outer">
        <div class="inside1490 textimgbox">
          <img
            class="fl"
            style="width: 768px;height: 378px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_05%402x.png"
          />
          <div class="fr">
            <h2>一键发薪及报税</h2>
            <p class="text_detail">对接银行系统，一键完成发薪<br/> 自动生成报税数据<br/> 自动生成发薪报税台账</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--文字图片排版2-->
       <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">业务流程灵活配置</h2>
            <p class="text_detail">自定义配置审批流程<br/> 审批流程自动触发业务<br/> 支持移动端审批，操作更自由</p>
          </div>
          <img
            class="fr"
            style="width: 608px;height: 487px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/ecall/outsoruce_pic_06.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
        <!--图片文字排版1-->
        <div class="outer" >
        <div class="inside1490 textimgbox" style="height: 839px;">
          <img
            class="fl"
            style="width: 708px;height: 598px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_07%402x.png"
          />
          <div class="fr">
            <h2>一站式员工自助服务</h2>
            <p class="text_detail">员工可自助查询工资条<br/> 支持手机端请假、报销、证明开具等操作<br/> 规章制度、活动、福利政策等直达员工</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--文字图片排版2-->
       <div class="outer">
        <div class="inside1490 imgtextbox">
          <div class="fl">
            <h2 style="text-align: left">专享客户门户</h2>
            <p class="text_detail">根据客户自有风格灵活定制<br/> 可查看实时招聘信息<br/> 员工档案信息同步客户门户</p>
          </div>
          <img
            class="fr"
            style="width: 768px;height: 457px;margin-top: 120px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_08%402x.png"
          />
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
       <!--图片文字排版1-->
       <div class="outer">
        <div class="inside1490 textimgbox">
          <img
            class="fl"
            style="width: 768px;height: 478px;margin-top: 122px;"
            src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/pic_09%402x.png"
          />
          <div class="fr">
            <h2>业务财务一体化</h2>
            <p class="text_detail">实时项目成本核算与控制<br/> 统一的财务与业务数据管理<br/> 财务分析助力业务决策</p>
          </div>
        </div>
      </div>
      <!--清除浮动-->
      <div class="clear"></div>
      <div class="security outer">
          <div class="inside1490 security_child">
            <div class="security_left"><img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/icon_customer_service%402x.png"/></div>
            <div class="security_right">
              <p class="p1">即刻开启数字化招聘人效提升之旅</p>
              <!-- <div class="security_center" @click="trial()">申请试用</div> -->
            </div>
           
          </div>
      </div>
     <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="''" :he="true" @handleChange="changewindows" />
    </div>
</template>
<script>
  import populone from "@/components/views/popul/populone";
  export default {
    name: "productoutsource",
    data() {
        return{
            windowflags: false,
        }
    },
    components: {
        populone,
    },
    methods:{
      trial(){
        this.windowflags = true;
        },
        changewindows(value) {
         this.windowflags = value;
        },
    },
    metaInfo: {
        title: '易猎云外包管理系统-业财一体的外包/派遣员工管理系统',
        meta: [
          {
            name: 'keywords',
            content: '外包管理系统，派遣管理系统，社保增、商保、公积金增减员，人事管理，发薪报税，工资条，账单管理，流失管控'
          },
          {
            name: 'description',
            content: '猎云外包管理系统是一款专为人力资源服务企业打造的业财一体的HRO管理服务系统，致力于帮助外包企业高效地管理外包项目、提升外包服务质量，并优化成本控制，减少项目风险'
          }
        ]
    },
}
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";
.productoutsource{
    margin-top: 85px;
    .banner {
      width: 100%;
      height: 730px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/product/banner1png%402x.png');
      background-repeat: no-repeat;
      background-size: 100%;
      padding-top: 230px;
      box-sizing: border-box;
      .banner_title{
        font-size: 60px;
        color: #1D2754;
        line-height: 112px;
      }
      .banner_rpo{
        display: inline-block;
        width: 80px;
        height: 34px;
        border-radius: 7px;
        border: 1px solid #5666FF;
        font-size: 20px;
        color: #5666FF;
        line-height: 34px;
        text-align: center;
        vertical-align: top;
        margin-top: 30px;
      }
      .banner_txt{
        font-size: 24px;
        color: #3A4D70;
        line-height: 40px;
      }
    }
    .textimgbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 126px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 453px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .imgtextbox {
      width: 1490px;
      height: 610px;
      border-bottom: solid 1px #E4E6EE;
      h2 {
        font-size: 42px;
        margin-top: 120px;
        font-weight: 500;
        color: #1d2754;
        line-height: 48px;
      }
      .text_detail{
        width: 408px;
        font-size: 24px;
        color: #7087A6;
        line-height: 42px;
        margin-top: 31px;
      }
    }
    .clear {
      clear: both;
    }
    .security{
      width: 100%;
      height: 277px;
      background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyofficialWebImagse/v2/bg_01%402x.png');
      background-repeat: no-repeat;
      background-size: 100% 102%;
      padding-top: 53px;
      box-sizing: border-box;
      .security_child{
        display: flex;
        .security_left{
            margin-left: 197px;
              img{
                width: 145px;
                height: 128px;
              }
        }
        .security_right{
             margin-left: 37px;
              .p1{
              display: inline-block;
              font-size: 48px;
              font-weight: 500;
              color: #ffffff;
              text-align: left;
              margin-top: 47px;
          }
        }
        .security_center{
          width: 158px;
          height: 66px;
          background: #FFFFFF;
          border-radius: 7px;
          line-height: 66px;
          text-align: center;
          font-size: 24px;
          color: #215FFF;
          cursor: pointer;
          margin: 0 auto;
          margin-top: 40px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/product/productoutsource.vue